/**
 * Life4Earth V2 — API base URL resolution (web build).
 *
 * Extracted from client.ts for DEV-1418 (mobile Phase 1): this is the ONLY
 * file in the shared API client graph that may reference `import.meta.env`
 * (a Vite-ism that Metro/Hermes cannot compile). The React Native app
 * substitutes its own implementation of this module via a Metro resolver
 * alias (see mobile/metro.config.js). Do NOT add import.meta, window,
 * document, or localStorage references to client.ts or the API adapter
 * modules — put platform-specific code here or in src/api/authBridge.ts
 * registrations.
 *
 * DEV-1297 self-host: use `??` not `||` so an *explicit* empty string
 * (VITE_API_BASE_URL="" at build time) is honored as "call the same origin
 * with relative URLs" — the single-origin model behind Caddy/ngrok. With `||`
 * the empty string is falsy and wrongly fell back to localhost:5295, which
 * pointed every visitor's browser at THEIR OWN machine (and is blocked as
 * mixed content over https). Unset (dev) still falls back to localhost:5295.
 */
// Interface-merge declarations so this file typechecks under BOTH tsconfigs:
// the web config gets these from vite/client (merging is a no-op there);
// the mobile config (mobile/tsconfig.json) has no Vite types and needs them.
// (Metro never compiles this file — mobile/metro.config.js aliases it away —
// but `tsc` in mobile/ still type-follows the real import.)
declare global {
  interface ImportMetaEnv {
    // Must match src/vite-env.d.ts exactly (TS2687 on modifier drift).
    readonly VITE_API_BASE_URL: string;
  }
  interface ImportMeta {
    readonly env: ImportMetaEnv;
  }
}

export const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL ?? "http://localhost:5295";
